export const ADMIN_PERMISSIONS = [
  { key: 'dashboard', label: 'Хянах самбар' },
  { key: 'home_config', label: 'Нүүр хуудас' },
  { key: 'courses', label: 'Сургалтууд' },
  { key: 'videos', label: 'Видео' },
  { key: 'teachers', label: 'Багш нар' },
  { key: 'posts', label: 'Нийтлэлүүд' },
  { key: 'users', label: 'Хэрэглэгчид' },
  { key: 'payments', label: 'Төлбөрүүд' },
  { key: 'payment_settings', label: 'Төлбөрийн тохиргоо' },
  { key: 'categories', label: 'Ангилал тохиргоо' },
  { key: 'system_users', label: 'Системийн хэрэглэгчид' },
] as const;

export type AdminPermissionKey = (typeof ADMIN_PERMISSIONS)[number]['key'];
